export default __webpack_public_path__ + "static/media/bateria2tom.6e3007ad.png";